var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardAzureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.142853,
    y: 0.142647,
    width: 7.54286,
    height: 7.54286,
    fill: "#F25022"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.142883,
    y: 8.31392,
    width: 7.54286,
    height: 7.54286,
    fill: "#02A4EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.3143,
    y: 0.142441,
    width: 7.54286,
    height: 7.54286,
    fill: "#80BA01"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.3143,
    y: 8.31392,
    width: 7.54286,
    height: 7.54286,
    fill: "#FFB902"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardAzureIcon);
export default __webpack_public_path__ + "static/media/onboard-azure-icon.8f5b2a56b48c47c41bff1d128c1f95c8.svg";
export { ForwardRef as ReactComponent };